import React from "react";
import { Container, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import "./footer.css";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

const Footer = () => {
  return (
    <div className="footer-box" >
      <Container>
        <Grid container spacing={2}>
            <Grid xs={12} sm={12} md={8} lg={8} className="footer-left">
              <Typography variant="h4" className="footer-heading">
                Have a project in mind? <span> I'm available to work!👨‍💻 </span>
              </Typography>
            </Grid>
            <Grid xs={12} sm={12} md={4} lg={4} sx={{pl:1}} className="footer-right">
                <a href="https://github.com/ahsan-chy" target="_blank" rel="noreferrer" className="social-box">
                    <GitHubIcon className="icon"/>
                </a>
                <a href="https://www.linkedin.com/in/ahsan-iqball/" target="_blank" rel="noreferrer" className="social-box">
                    <LinkedInIcon className="icon"/>
                </a>
                <a href="mailto:ahsan.chy.iqbal.com?subject=Hi!%20I%20want%20To%20Hire%20you" target="_blank" rel="noreferrer" className="social-box">
                    <MailOutlineIcon className="icon"/>
                </a>
            </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Footer;
